import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { API } from "@/lib/api";

// All texts come from the backend (backend/locales/*.json, picked by APP_LANGUAGE).
// The frontend has no language switch and no strings of its own.
let valueLabels = {};
let months = [];

export async function loadTranslations() {
  const res = await fetch(`${API}/i18n`);
  if (!res.ok) throw new Error(`GET /i18n: ${res.status}`);
  const { language, months: monthNames, ui, values } = await res.json();
  valueLabels = values || {};
  months = monthNames || [];
  await i18n.use(initReactI18next).init({
    lng: language,
    resources: { [language]: { translation: ui } },
    interpolation: { escapeValue: false }, // React escapes already
    returnNull: false,
  });
  document.documentElement.lang = language;
  document.title = i18n.t("html_title");
}

// Display label of a stored form value (e.g. "Married"); unknown values are shown as they are.
export const valueLabel = (v) => (v != null && valueLabels[v]) || v;

// A review answer, and the tally of a choice criterion across reviews ({yes, no, maybe}).
export const choiceLabel = (v) => (v ? i18n.t(`choices.${v}`, { defaultValue: String(v) }) : "—");
export const tallyLabel = (tally) => {
  if (!tally || typeof tally !== "object") return "—";
  const parts = ["yes", "maybe", "no"].filter((k) => tally[k]).map((k) => i18n.t(`tally.${k}`, { count: tally[k] }));
  return parts.length ? parts.join(" · ") : "—";
};

// Dates are formatted here with the catalog's month names (like the deadline texts from the API):
// browsers ship incomplete date data for some languages, e.g. Albanian.
const pad = (n) => String(n).padStart(2, "0");
export const fmtTime = (iso) => { const d = new Date(iso); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; };
export const fmtDate = (iso) => { const d = new Date(iso); return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`; };
export const fmtDateTime = (iso) => `${fmtDate(iso)}, ${fmtTime(iso)}`;

export default i18n;
